import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const adminApi = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Auth
export const login = (email, password) =>
  adminApi.post('/admin/login', { email, password }).then((r) => r.data);
export const logout = () => adminApi.post('/admin/logout').then((r) => r.data);
export const me = () => adminApi.get('/admin/me').then((r) => r.data);

// Dashboard
export const getDashboard = () => adminApi.get('/admin/dashboard').then((r) => r.data);

// Sections
export const listSection = (section, params = {}) =>
  adminApi.get(`/admin/${section}`, { params }).then((r) => r.data);
export const getRecord = (section, id) =>
  adminApi.get(`/admin/${section}/${id}`).then((r) => r.data);
export const updateRecord = (section, id, payload) =>
  adminApi.patch(`/admin/${section}/${id}`, payload).then((r) => r.data);
export const resyncNewsletter = (id) =>
  adminApi.post(`/admin/newsletter/${id}/resync`).then((r) => r.data);
export const listAll = (params = {}) =>
  adminApi.get('/admin/submissions/all', { params }).then((r) => r.data);

export const exportCsvUrl = (section, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return `${API}/admin/${section}/export.csv${qs ? `?${qs}` : ''}`;
};

export const SECTION_STATUSES = {
  contacts: ['new', 'reviewing', 'contacted', 'follow_up', 'completed', 'archived'],
  speaking: ['new', 'reviewing', 'discovery_call', 'proposal_sent', 'confirmed', 'declined', 'completed', 'archived'],
  newsletter: ['active', 'unsubscribed', 'bounced', 'complained', 'suppressed', 'sync_error'],
  waitlist: ['new', 'qualified', 'contacted', 'invited', 'converted', 'not_interested', 'archived'],
};

export const STATUS_LABELS = {
  new: 'New',
  reviewing: 'Reviewing',
  contacted: 'Contacted',
  follow_up: 'Follow-Up',
  completed: 'Completed',
  archived: 'Archived',
  discovery_call: 'Discovery Call',
  proposal_sent: 'Proposal Sent',
  confirmed: 'Confirmed',
  declined: 'Declined',
  active: 'Active',
  unsubscribed: 'Unsubscribed',
  bounced: 'Bounced',
  complained: 'Complained',
  suppressed: 'Suppressed',
  sync_error: 'Sync Error',
  qualified: 'Qualified',
  invited: 'Invited',
  converted: 'Converted',
  not_interested: 'Not Interested',
};
